import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';

const PopOut = ({text, direction, dynamic}) => (
    <div
        className={classNames('pop-out--wrapper', `pop-out--${direction}`,
            {'pop-out--dynamic': dynamic},
            {'pop-out--static': !dynamic},
        )}
    >
        <div
            className={
                classNames('pop-out', `pop-out--${direction}`,
                    {'pop-out--dynamic': dynamic},
                    {'pop-out--static': !dynamic},
                )}
        >
            <span>{text}</span>
        </div>
    </div>
);

PopOut.propTypes = {
    text: PropTypes.string.isRequired,
    direction: PropTypes.oneOf(['left', 'right']),
    dynamic: PropTypes.bool,
};

PopOut.defaultProps = {
    direction: 'left',
    dynamic: true,
};

export default PopOut;



// WEBPACK FOOTER //
// ./src/components/PopOut.js